<div class="flex min-h-screen flex-col">
  <!-- Header -->
  <header class="bg-primary-50">
    <div class="mx-auto max-w-screen-lg">
      <app-header />
    </div>
  </header>

  <!-- Hero -->
  <main class="flex flex-auto flex-col">
    <router-outlet />
  </main>

  <!-- Footer -->
  <footer class="bg-[#141b2e]">
    <div class="mx-auto max-w-screen-lg">
      <app-footer />
    </div>
  </footer>
</div>
